import { Typography } from "@/components/atoms";

export const ClientReferrals = () => {
  return (
    <div className="py-6">
      <Typography variant="h2">Referrals</Typography>
    </div>
  );
};
